/**
 * Template Theme Configuration
 * 每個模板的完整配色方案，用於建立 MUI Theme
 */

const TEMPLATE_THEMES = {
  classic: {
    mode: 'light',
    primary: '#1976d2',
    primaryLight: '#42a5f5',
    primaryDark: '#1565c0',
    secondary: '#dc004e',
    background: '#f5f5f5',
    paper: '#ffffff',
    accent: '#ff9800',
    saleBadge: '#e53935',
    hoverTint: '#e3f2fd',
    headerGradient: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
    footerBg: '#1a237e',
    footerPaper: '#283593',
    categoryColors: ['#1976d2', '#1565c0', '#0d47a1', '#42a5f5', '#1e88e5', '#1976d2', '#1565c0', '#0d47a1'],
  },
  fashion: {
    mode: 'light',
    primary: '#c9a84c',
    primaryLight: '#d4b96a',
    primaryDark: '#a68a3e',
    secondary: '#1a1a1a',
    background: '#faf9f6',
    paper: '#ffffff',
    accent: '#c9a84c',
    saleBadge: '#c9a84c',
    hoverTint: '#f5f0e0',
    headerGradient: 'linear-gradient(135deg, #1a1a1a 0%, #333333 100%)',
    footerBg: '#1a1a1a',
    footerPaper: '#2a2a2a',
    categoryColors: ['#c9a84c', '#a68a3e', '#8b7332', '#d4b96a', '#bfa044', '#c9a84c', '#a68a3e', '#8b7332'],
  },
  handmade: {
    mode: 'light',
    primary: '#8b6f47',
    primaryLight: '#a6875e',
    primaryDark: '#6d5636',
    secondary: '#c67a4b',
    background: '#faf5ef',
    paper: '#ffffff',
    accent: '#c67a4b',
    saleBadge: '#c67a4b',
    hoverTint: '#f5ebe0',
    headerGradient: 'linear-gradient(135deg, #8b6f47 0%, #a6875e 100%)',
    footerBg: '#3e2723',
    footerPaper: '#4e342e',
    categoryColors: ['#8b6f47', '#6d5636', '#a6875e', '#c67a4b', '#7b5e3b', '#8b6f47', '#6d5636', '#a6875e'],
  },
  food: {
    mode: 'light',
    primary: '#d4503a',
    primaryLight: '#e07060',
    primaryDark: '#b03a28',
    secondary: '#f58634',
    background: '#fffaf5',
    paper: '#ffffff',
    accent: '#f58634',
    saleBadge: '#d4503a',
    hoverTint: '#fff3e0',
    headerGradient: 'linear-gradient(135deg, #d4503a 0%, #f58634 100%)',
    footerBg: '#3e2723',
    footerPaper: '#4e342e',
    categoryColors: ['#d4503a', '#b03a28', '#f58634', '#e8601c', '#c4402a', '#d4503a', '#b03a28', '#f58634'],
  },
  tech: {
    mode: 'dark',
    primary: '#58a6ff',
    primaryLight: '#79b8ff',
    primaryDark: '#388bfd',
    secondary: '#3fb950',
    background: '#0d1117',
    paper: '#161b22',
    accent: '#3fb950',
    saleBadge: '#f85149',
    hoverTint: '#1c2128',
    headerGradient: 'linear-gradient(135deg, #161b22 0%, #0d1117 100%)',
    footerBg: '#010409',
    footerPaper: '#0d1117',
    categoryColors: ['#58a6ff', '#388bfd', '#79b8ff', '#3fb950', '#58a6ff', '#388bfd', '#79b8ff', '#3fb950'],
  },
};

/**
 * 取得模板主題配色
 * @param {string} templateId - 模板 ID (classic, fashion, handmade, food, tech)
 * @returns {object} 完整配色方案
 */
export const getTemplateTheme = (templateId) => {
  return TEMPLATE_THEMES[templateId] || TEMPLATE_THEMES.classic;
};

/**
 * 判斷是否為暗色模式
 */
export const isDarkMode = (templateId) => {
  const theme = getTemplateTheme(templateId);
  return theme.mode === 'dark';
};

export default TEMPLATE_THEMES;
